import "./bootstrap-defaults";
import * as Sentry from "@sentry/angular";
import { bootstrapApplication } from "@angular/platform-browser";
import { appConfig } from "./app/app.config";
import { AppComponent } from "./app/app.component";
import { sentryEnv } from "@environments/sentry-env/sentry-env";

/**
 * Monkey-patch to open Shadow DOM for Google Maps Place Autocomplete Element
 * This allows custom styling of the component by converting closed Shadow DOM to open
 */
(function openGoogleMapsPlaceShadowDOM() {
  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init: ShadowRootInit) {
    if (this.localName === "gmp-place-autocomplete") {
      init.mode = "open";
    }
    return originalAttachShadow.call(this, init);
  };
})();

if (sentryEnv.enabled) {
  Sentry.init(sentryEnv.options);
}

bootstrapApplication(AppComponent, {
  providers: appConfig.providers,
}).catch(err => console.error(err));
